// ...existing code...

// Metni baş harflerini büyük yapar
export const capitalize = (str) => str.replace(/\b\w/g, (char) => char.toUpperCase());

// Türkçe karakterleri İngilizceye çevirir ve URL-encoded veriyi çözer
export const formatUrlName = (name) => {
  const turkishToEnglishMap = {
    ç: 'c',
    Ç: 'C',
    ğ: 'g',
    Ğ: 'G',
    ı: 'i',
    İ: 'I',
    ö: 'o',
    Ö: 'O',
    ş: 's',
    Ş: 'S',
    ü: 'u',
    Ü: 'U',
  };

  return decodeURIComponent(name)
    .normalize('NFD') // Unicode normalizasyonu
    .replace(/[\u0300-\u036f]/g, '') // Aksanları temizle
    .split('')
    .map((char) => turkishToEnglishMap[char] || char) // Harfleri dönüştür
    .join('')
    .replace(/%20/g, ' '); // Boşlukları düzelt
};

// URL yolunu formatlar
export const formatUrlPath = (url) => {
  return url
    .split('/')
    .map((segment) => formatUrlName(segment))
    .join('/');
};

// Menü elemanlarından çeviri tablosu oluşturur
export const createTranslationTable = (items) =>
  items.reduce((table, item) => {
    if (item.children) {
      return { ...table, ...createTranslationTable(item.children) };
    }
    return { ...table, [item.key]: item.title };
  }, {});

// Metni Title Case formatına dönüştürür
export const toTitleCase = (str) =>
  str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toLocaleUpperCase('tr-TR') + word.slice(1))
    .join(' ');
